/* global window, document */

import React, { useContext } from "react";
import { compose } from "redux";
import { Grid, MobileStepper } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import PropTypes from "prop-types";
import CourseCard from "../CourseCard/CourseCard";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
// TODO: remove them
import defaultPic1 from "../../assets/images/default_pic_1.png";
import defaultPic2 from "../../assets/images/default_pic_2.png";
import defaultPic3 from "../../assets/images/default_pic_3.png";
import defaultPic4 from "../../assets/images/default_pic_4.png";
import UserAssignmentContext from "../../context/UserAssignmentContext";
import CourseActionButton from "../Buttons/CourseActionButton";
import { assignmentTypes } from "../../constants";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = theme => ({
  recommendedCoursesContainer: {
    flexShrink: 0,
    height: "100%",
    margin: theme.spacing(0, -1.5),
    width: "100%"
  },
  stepper: {
    marginTop: theme.spacing(1.5)
  },
  activeDot: {
    backgroundColor: theme.palette.primary.main
  }
});

const defaultPictures = [defaultPic1, defaultPic2, defaultPic3, defaultPic4]; //TODO: remove this code after course images are properly implemented

const CoursesContainer = ({ courseSet }) => {
  const {
    onStartCourse,
    onCreateUserAssignment,
    onResumeAssignment,
    isEnrolled,
    isStarted
  } = useContext(UserAssignmentContext);

  return courseSet.map((course, index) => {
    const userAssignment = course.userAssignment;
    return (
      <Grid item xs={12} sm={6} md={3} key={`course-${index}`}>
        <CourseCard
          buttons={[
            <CourseActionButton
              isEnrolled={isEnrolled(course)}
              isAssigned={!!userAssignment}
              isStarted={isStarted(userAssignment)}
              courseType={course.courseType}
              onEnrollClick={() => onStartCourse(course)}
              onResumeCourseClick={() => onResumeAssignment(userAssignment)}
              onAddToCoursesClick={() => onCreateUserAssignment(course)}
              isInstructorForCourse={course.isInstructorForCourse}
              prereqs={course.prerequisites || []}
              startDate={course.zonedStartDate}
              endDate={course.zonedEndDate}
              iltClassType={course.typeName}
            />
          ]}
          gridView
          title={course.name}
          imageSrc={
            course.image
              ? course.image
              : defaultPictures[Math.floor(Math.random() * 4)]
          }
          courseType={course.courseType}
          typeName={course.typeName}
          flags={course.flags}
          hasNote={!!userAssignment}
          isSelfAssigned={
            userAssignment?.assignmentType == assignmentTypes.self
          }
          courseDescription={course.description}
          location={course.iltInfo ? course.iltInfo.trainingLocation : null}
          scheduledDate={course.scheduledDate}
          scheduledTime={course.scheduledTime}
        />
      </Grid>
    );
  });
};

class ScrollableCourseCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coursesSetSize: 4,
      activeStep: 0 // The amount of courses to be shown in the scrollable container at a time
    };

    this.handleStepChange = this.handleStepChange.bind(this);
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const { theme } = this.props;
    const windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    if (windowWidth < theme.breakpoints.values.md) {
      this.setState({ coursesSetSize: 2 });
    } else if (windowWidth < theme.breakpoints.values.sm) {
      this.setState({ coursesSetSize: 1 });
    } else {
      this.setState({ coursesSetSize: 4 });
    }
  };

  handleStepChange(step) {
    this.setState({ activeStep: step });
  }

  render() {
    const { courses, classes } = this.props;
    const { coursesSetSize, activeStep } = this.state;

    if (!courses || courses.length === 0) {
      return null;
    }
    const courseSets = [];
    for (let i = 0; i < courses.length; i += coursesSetSize) {
      courseSets.push(courses.slice(i, i + coursesSetSize));
    }
    return (
      <>
        <AutoPlaySwipeableViews
          interval={7000}
          axis="x"
          index={activeStep}
          onChangeIndex={this.handleStepChange}
          enableMouseEvents
        >
          {courseSets.map((courseSet, index) => (
            <Grid
              container
              spacing={3}
              className={classes.recommendedCoursesContainer}
              key={`container-${index}`}
            >
              <CoursesContainer courseSet={courseSet} />
            </Grid>
          ))}
        </AutoPlaySwipeableViews>
        <MobileStepper
          steps={courseSets.length}
          activeStep={activeStep}
          variant="dots"
          position="static"
          classes={{ root: classes.stepper, dotActive: classes.activeDot }}
        />
      </>
    );
  }
}

export default compose(withStyles(styles, { withTheme: true }))(
  ScrollableCourseCards
);

ScrollableCourseCards.propTypes = {
  courses: PropTypes.arrayOf(PropTypes.any),
  theme: PropTypes.object,
  classes: PropTypes.object
};
